/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Foreignlanguages_Nepali2Inputs */

const en__field__enum_foreignlanguages_nepali2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Nepali2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepali`)
};

const de__field__enum_foreignlanguages_nepali2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Nepali2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepali`)
};

/**
* | output |
* | --- |
* | "Nepali" |
*
* @param {_Field__Enum_Foreignlanguages_Nepali2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_foreignlanguages_nepali2 = /** @type {((inputs?: _Field__Enum_Foreignlanguages_Nepali2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Foreignlanguages_Nepali2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_foreignlanguages_nepali2(inputs)
	return de__field__enum_foreignlanguages_nepali2(inputs)
});
export { _field__enum_foreignlanguages_nepali2 as "_field__enum_foreignLanguages_Nepali" }